
import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import PTOFile from '../Resources/Example of PTO Balance.csv';
import Checkbox from '@material-ui/core/Checkbox';
import { Redirect } from 'react-router-dom';
import PTOService from '../Services/PTOService/ptoService';
import { css } from 'react-emotion';
// import Radio from '@material-ui/core/Radio';
// First way to import
import { ClipLoader } from 'react-spinners';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}
// const customStyles = {
//     container: (base, state) => ({
//       ...base,
//       border: state.isFocused ? null : null,
//       transition:
//         "border-color 0.2s ease, box-shadow 0.2s ease, padding 0.2s ease",
//       "&:hover": {
//         boxShadow: "0 2px 4px 0 rgba(41, 56, 78, 0.1)",
//         width: "10px"
//       }
//     })

//   };

class PTOImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            PTOList: { pennding: false, value: [] },
            PTOUpList: { pennding: false, value: [] },
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HPTOUserID: false,
            HPTOName: false,
            HPTOAbsenceTypeID: false,
            HPTOHoursAvailable: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        // this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleHPTOUserID = this.handleHPTOUserID.bind(this);
    }

    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            PTOUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });
        if (uploadedFile) {
            if (extFile.toUpperCase() !== "CSV") {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                //let target = progressEvent.target; 
                //let result = target.result;               
                var base64result = reader.result.split(',')[1];
                var encoded = base64.decode(base64result);
                var data = encoded.split('\n');
                var DataList = [];
                data.forEach(element => {
                    DataList.push(element.split(','));
                });
                //console.log(DataList)
                var UserID = "";
                var UserName = "";
                var AbsenceTypeID = "";
                var HoursAvailable = "";
                DataList[0].forEach(function (element) {

                    if (element.replace(/\s/g, "").toUpperCase() === "EMPLOYEEID") {

                        UserID = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "EMPLOYEENAME") {

                        UserName = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "ABSENCETYPEID") {

                        AbsenceTypeID = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "BALANCE") {

                        HoursAvailable = element;
                    }
                });

                this.setState({
                    PTOUpList: { pennding: true, value: DataList },
                    HeadersList: DataList[0],
                    Headers: true,
                    UploadFileName: name,
                    HPTOUserID: { value: UserID, label: UserID },
                    HPTOName: { value: UserName, label: UserName },
                    HPTOAbsenceTypeID: { value: AbsenceTypeID, label: AbsenceTypeID },
                    HPTOHoursAvailable: { value: HoursAvailable, label: HoursAvailable }
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.setState({
                PTOUpList: { pennding: true, value: [] },
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });
        }
    }
    handleHPTOUserID = event => {

        this.setState({
            HPTOUserID: event
        });
    }
    handleHPTOName = event => {
        this.setState({
            HPTOName: event
        });
    }
    handleHPTOAbsenceTypeID = event => {
        this.setState({
            HPTOAbsenceTypeID: event
        });
    }
    handleHPTOHoursAvailable = event => {
        this.setState({
            HPTOHoursAvailable: event
        });
    }
    UploadPTOList(e) {
        e.preventDefault();
        var ActionType = this.state.selectedValue;
        var DataList = this.state.PTOUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderPTOUserID = this.state.HPTOUserID.value;
        // var HeaderPTOName = this.state.HPTOName.value;//unused, don't know why
        var HeaderPTOAbsenceTypeID = this.state.HPTOAbsenceTypeID.value;
        var HeaderPTOHoursAvailable = this.state.HPTOHoursAvailable.value;
        var Result = [];

        var positionPTOUserID = HeaderListist.indexOf(HeaderPTOUserID);
        // var positionPTOName = HeaderListist.indexOf(HeaderPTOName);//unused, don't know why
        var positionPTOAbsenceTypeID = HeaderListist.indexOf(HeaderPTOAbsenceTypeID);
        var positionPTOHoursAvailable = HeaderListist.indexOf(HeaderPTOHoursAvailable);

        if (positionPTOUserID === -1) {
            toast.error("PTO EmployeeID field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionPTOAbsenceTypeID === -1) {
            toast.error("PTO AbsenceTypeID field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionPTOHoursAvailable === -1) {
            toast.error("PTO Balance field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }

        // var PTOName = ""; //unused, don't know why
        for (var i = 1; i < (DataList.length - 1); i++) {

            // if (positionPTOName === -1)
            //     PTOName = "";
            // else
            //     PTOName = DataList[i][positionPTOName];

            if (DataList[i] !== "") {
                Result.push({
                    USERID: DataList[i][positionPTOUserID], ABSENCE_TYPE_ID: DataList[i][positionPTOAbsenceTypeID],
                    HOURS_AVAILABLE: DataList[i][positionPTOHoursAvailable]
                });
            }
        }
        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {

            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {

            if (this.props.CompanyCode && DataList) {
                this.setState({
                    PTOList: { pennding: true, value: [] }
                });

                var ListResult = PTOService.getPTOListResult(this.props.CompanyCode, Result, ActionType);
                var that = this;
                ListResult.then(function (data) {
                    if (data.status === 200) {
                        that.setState({
                            PTOList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    }
                }).catch((error) => {

                    that.setState({
                        PTOList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }
    handleChange = event => {
        this.setState({
            selectedValue: event.target.value,
            PTOList: { pennding: false, value: [] }
        });
    }
    onChange(e, code) {

        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {
        if (e.target.checked) {
            let optionChecked = [];
            this.state.PTOList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.USERID);
            })
            this.setState({ checkboxOptions: optionChecked })
        } else {
            this.setState({ checkboxOptions: [] })
        }
    }
    SavePTOList(e) {
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions;
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];
        var that = this;

        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a PTO and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var PTO = this.state.PTOList.value.find(x => x.USERID === l);
                result.push(PTO);
            })
            var DataResult = PTOService.SavePTO(this.props.CompanyCode, result, ActionType, email);
            DataResult.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        loading: false,
                        PTOList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.success("PTOs Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "InUse") {
                    that.setState({
                        loading: false,
                        PTOList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("PTO Code in Use!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "AuditError") {
                    that.setState({
                        loading: false,
                        PTOList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "No") {
                    that.setState({
                        loading: false,
                        PTOList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            }).catch((error) => {
                that.setState({
                    loading: false,
                    PTOList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: ""
                });
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }
    changeName(e) {
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();

        if (extention.toUpperCase() === "CSV") {
            this.setState({
                FileName: res
            });
        } else {
            this.setState({
                FileName: "CHOOSE A FILE",
                PTOUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        return true;
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }
        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            // return <option key={item} className="dropdown-item" href="#" value={item} >{item}</option>
            return { value: item, label: item }
        });
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">PTO Balance</span></h4>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-3 offset-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={Math.random() * 1200000}>
                                        <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.handleData(event) }} />
                                    </div>
                                }
                            </div>
                            <div className="col-2 offset-4">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={PTOFile} download="Example of PTO Balance.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>

                        </div>
                        <br /> <br />
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2 offset-1">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', display: "inline-block" }} className="">Employee ID(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HPTOUserID}
                                            onChange={this.handleHPTOUserID}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', display: "inline-block"}} className="">Employee Name(<span style={{color: 'red'}}>*</span>):</label>
                                        <Select
                                            value={this.state.HPTOName}
                                            onChange={this.handleHPTOName}
                                            options={optionItemsHeaders}
                                            styles={{  width: "10px"}}
                                        />
                                    </div>
                                </div> */}
                                <div className="col-2">
                                    <div className="form-group ">
                                        <label style={{ 'fontWeight': '900', display: "inline-block" }} className="">Absence Type ID(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HPTOAbsenceTypeID}
                                            onChange={this.handleHPTOAbsenceTypeID}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', display: "inline-block" }} className="">Balance(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HPTOHoursAvailable}
                                            onChange={this.handleHPTOHoursAvailable}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2" style={{ paddingTop: '28px' }}>
                                    <button className="btn btn-info" onClick={(e) => { this.UploadPTOList(e) }} >Preview</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {
                    (this.state.PTOList.pennding
                        && <span className="loader"></span>)
                    ||
                    (this.state.PTOList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body">
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto' }}>
                                    <table className="table table-hover table-striped table-sm" >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                <th scope="col">Employee ID</th>
                                                <th scope="col">Employee Name</th>
                                                <th scope="col">Absence Type ID</th>
                                                <th scope="col">Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody style={scrollTable}>
                                            {
                                                (this.state.PTOList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.PTOList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.USERID) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.USERID)}
                                                                        value={item.USERID}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                            }

                                                        </td>
                                                        <td>{item.USERID}</td>
                                                        <td>{item.USER_NAME}</td>
                                                        <td>{item.ABSENCE_TYPE_ID}</td>
                                                        <td>{item.HOURS_AVAILABLE}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SavePTOList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}
export default PTOImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/PTOImportfile.jsx